import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Users: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9699 14.4402C18.3399 14.6702 19.8499 14.4302 20.9099 13.7202C22.3199 12.7802 22.3199 11.2402 20.9099 10.3002C19.8399 9.59024 18.3099 9.35024 16.9399 9.59024M6.99994 14.4402C5.62994 14.6702 4.11994 14.4302 3.05994 13.7202C1.64994 12.7802 1.64994 11.2402 3.05994 10.3002C4.12994 9.59024 5.65994 9.35024 7.02994 9.59024M17.9999 7.16024C17.937 7.15024 17.8729 7.15024 17.8099 7.16024C17.1426 7.13611 16.5107 6.85345 16.0479 6.37201C15.5852 5.89056 15.3277 5.24804 15.3299 4.58024C15.3299 3.15024 16.4799 2.00024 17.9099 2.00024C18.5942 2.00024 19.2504 2.27206 19.7343 2.75591C20.2181 3.23975 20.4899 3.89599 20.4899 4.58024C20.4881 5.24852 20.2279 5.8902 19.7639 6.37106C19.2998 6.85191 18.6677 7.13469 17.9999 7.16024ZM5.96994 7.16024C6.02994 7.15024 6.09994 7.15024 6.15994 7.16024C6.82731 7.13611 7.45915 6.85345 7.92194 6.37201C8.38472 5.89056 8.64219 5.24804 8.63994 4.58024C8.63994 3.15024 7.48994 2.00024 6.05994 2.00024C5.37568 2.00024 4.71945 2.27206 4.23561 2.75591C3.75176 3.23975 3.47994 3.89599 3.47994 4.58024C3.48994 5.98024 4.58994 7.11024 5.96994 7.16024ZM11.9999 14.6302C11.937 14.6202 11.8729 14.6202 11.8099 14.6302C11.1426 14.6061 10.5107 14.3235 10.0479 13.842C9.58516 13.3606 9.32769 12.718 9.32994 12.0502C9.32994 10.6202 10.4799 9.47024 11.9099 9.47024C12.5942 9.47024 13.2504 9.74206 13.7343 10.2259C14.2181 10.7098 14.4899 11.366 14.4899 12.0502C14.4799 13.4502 13.3799 14.5902 11.9999 14.6302ZM9.08994 17.7802C7.67994 18.7202 7.67994 20.2602 9.08994 21.2002C10.6899 22.2702 13.3099 22.2702 14.9099 21.2002C16.3199 20.2602 16.3199 18.7202 14.9099 17.7802C13.3199 16.7202 10.6899 16.7202 9.08994 17.7802Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Users;
